import {Component, OnInit, ViewChild, Optional, ViewContainerRef} from '@angular/core';
import {CategoryMoneyService} from '../../_services/category-money.service';
import {DialogService} from 'ng2-bootstrap-modal';
import {AddCategoryMoneyComponent} from './add-category-money/add-category-money.component';
import {EditCategoryMoneyComponent} from './edit-category-money/edit-category-money.component';
import {ConfirmComponent} from '../../_common/confirm/confirm.component';
import {DataTableDirective} from 'angular-datatables';

@Component({
    selector: 'app-category-money',
    templateUrl: './category-money.component.html',
    styleUrls: ['./category-money.component.css']
})
export class CategoryMoneyComponent implements OnInit {

    searchWord: string;
    delayTimer: any;
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};

    constructor(
        private categoryMoneyService: CategoryMoneyService,
        private dialogService: DialogService) {
    }

    ngOnInit() {
        this.registerTable();
        if ($('.content-wrapper').height() < 838) {
            $('.content-wrapper').css('min-height', 838);
        }
    }

    registerTable() {
        let self = this;
        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.searchWord || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.categoryMoneyService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal
                    });
                });
            },
            columns: [
                {
                    title: "ID",
                    data: "id",
                    name: "id",
                    className: "all text-justify"
                },
                {
                    title: "カテゴリ名",
                    data: "category_name",
                    name: "category_name",
                    className: "all text-justify"
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-edit">編集</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                },
                {
                    title: "",
                    data: function (d) {
                        return `<button class="btn btn-sm btn-danger btn-delete">削除</button>`;
                    },
                    width: '60px',
                    className: "all text-center",
                    orderable: false
                }
            ],
            rowCallback: (row: Node, data: any[] | Object, index: number) => {
                const self = this;

                $('.btn-edit', row).bind('click', () => {
                    self.openEdit(data);
                });
                $('.btn-delete', row).bind('click', () => {
                    self.confirmDelete(data);
                });

                var btn_edit = $(row).find('td').find('.btn-edit');
                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });
                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });
                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                return row;
            }
        };
    }

    valuechange(newValue) {
        this.searchWord = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    openModalAddCategory() {
        let self = this;
        this.dialogService.addDialog(AddCategoryMoneyComponent).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.categoryMoneyService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

    confirmDelete(data) {
        this.dialogService.addDialog(ConfirmComponent, {
            title: '確認',
            message: '削除しますが、よろしいでしょうか？'
        }).subscribe((isConfirmed) => {
            if (isConfirmed) {
                this.categoryMoneyService.delete(data.id).subscribe(data => {
                    if (data.error == true) {
                        $("label.error").fadeIn(300).delay(3000).fadeOut(400);
                    }
                    this.loadCurrentPage();
                }, error => {

                });
            }
        });
    }

    openEdit(data) {
        this.dialogService.addDialog(EditCategoryMoneyComponent,
             { id: data.id, categoryName: data.category_name}
        ).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/category-money/category-money.component.ts